import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { AppRoute } from '../routes.types';
import Profile from '../../containers/UserPages/Profile/Profile';
import AnnouncementsTable from '../../containers/Announcements/AnnouncementsTable';
import StandardizationServicesPage from '../../containers/StandardizationServicesPage/StandardizationServicesPage';

const Notifications = lazyWithRetry(() => import('../../containers/Dashboard/Notifications/Notifications'));
const AuditLogs = lazyWithRetry(() => import('../../containers/AuditLogs/AuditLogsHost'));
const VenueSelection = lazyWithRetry(() => import('../../venues/pages/VenueSelectionPage/VenueSelectionPage'));
const Dashboard = lazyWithRetry(() => import('../../containers/Dashboard/Dashboard'));
const Associates = lazyWithRetry(() => import('../../containers/Associates/Associates'));
const CharityApproval = lazyWithRetry(() => import('../../containers/Referal/CharityApproval'));

export const ACCOUNT_ROUTES: AppRoute[] = [
    { path: '/profile', element: <Profile /> },
    { path: '/notifications', element: <Notifications /> },
    { path: '/audit-logs', element: <AuditLogs /> },
    { path: '/user-home', element: <VenueSelection /> },
    { path: '/venue-selection', element: <VenueSelection /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: '/announcements', element: <AnnouncementsTable /> },
    { path: '/associates', element: <Associates />, withAppShell: true },
    { path: '/charity-approval', element: <CharityApproval /> },
    { path: '/standardization-services', element: <StandardizationServicesPage />, withAppShell: true },
];
